import { useEffect, useState } from "react";
import { SimpleReferenceDetailStatus } from "../../interfaces/referenceDetaill";
import { useAuth } from "../../auth";
import { getCandidateByEmail } from "../../services/candidateService";
import { getReferencesByCandidateID } from "../../services/referenceDetailService";
import { formatDate } from "../../services/helpers";
import { ReferenceLetter } from "../../interfaces/referenceLetter";
import { loadReferenceLetters } from "../../services/referenceLetterService";
import ToolTip from "../../components/component-tools/ToolTip";

const ReferenceStatuses = () => {
  const [loading, setLoading] = useState(true);
  const { decodeToken } = useAuth();
  const [referenceDetails, setReferenceDetails] = useState<
    SimpleReferenceDetailStatus[] | null
  >(null);
  const [allLetters, setAllLetters] = useState<
    Record<number, ReferenceLetter[]>
  >({});

  useEffect(() => {
    const loadReferences = async () => {
      try {
        const email = decodeToken(localStorage.getItem("token") || "");
        const candidate = await getCandidateByEmail(email);

        const referenceDetailResponse = await getReferencesByCandidateID(
          candidate.candidateID,
        );
        setReferenceDetails(referenceDetailResponse);
      } catch (error) {
        console.error("Error loading reference details for candidate:", error);
      } finally {
        setLoading(false);
      }
    };
    loadReferences();
  }, [decodeToken]);

  useEffect(() => {
    const fetchReferenceLetters = async () => {
      try {
        if (referenceDetails && referenceDetails.length > 0) {
          const lettersMap = await loadReferenceLetters(referenceDetails);
          setAllLetters(lettersMap);
        }
      } catch (error) {
        console.error("Error fetching reference letters:", error);
      }
    };

    fetchReferenceLetters();
  }, [referenceDetails]);

  return (
    <div className="content-container">
      <div className="header-container">
        <h1 style={{ display: "flex" }}>
          Reference Status
          <ToolTip
            tooltipText="References that have yet to respond."
            placement="right"
            className="info-icon"
          />
        </h1>
        <div className="page-items-container"></div>
      </div>

      {loading ? (
        <div className="loading-divider">
          <div className="loading-bar"></div>
        </div>
      ) : (
        <>
          <div className="divider"></div>
          {/* <div className="text-body">
            <div>
              <ol className="alphabet-list">
                <li>
                  All educational institutions you have attended for at least
                  one quarter/semester or more in the past x amount of years.
                </li>
                <li>
                  All those who employed you, or congregations you have served
                  in the past x amount of years. If you have been at your
                  current position for more than «years» years, please provide
                  your two most recent employers/congregations. You should
                  consider yourself to have been "employed" by any entity for
                  which you provided substantial services, whether or not you
                  were paid for those services.
                </li>
                <li>
                  All bishops, past and present, who have had canonical
                  authority over you. Only ordained persons should complete this
                  section.
                </li>
              </ol>
            </div>
          </div>
          <div className="divider-small"></div> */}
          <div className="orders-container">
            {referenceDetails && referenceDetails.length > 0 ? (
              <div className="orders-list-small" style={{ width: "100%" }}>
                {referenceDetails.map((detail) => {
                  const letters = allLetters[detail.referenceDetailID] || [];
                  const lastLetter =
                    letters.length > 0 ? letters[letters.length - 1] : null;
                  return (
                    <div
                      key={detail.referenceDetailID}
                      className="order-card-small"
                      style={{ cursor: "default" }}
                    >
                      <div className="reference-card">
                        <div className="reference-name">
                          {detail.placeName} - {detail.referenceName}
                        </div>
                        <div className="reference-contacted">
                          Last Contacted:
                          <div className="chip-date">
                            {lastLetter?.letterDate
                              ? formatDate(lastLetter?.letterDate, "us")
                              : "-"}
                          </div>
                        </div>

                        {detail.letterReturned ? (
                          <div className="received-date">
                            Received Date:
                            <div className="chip-date">
                              {formatDate(detail.letterReturned, "us")}
                            </div>
                          </div>
                        ) : (
                          <div className="chip-no-response">
                            <div>{"NO RESPONSE"}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="text-body">No references.</div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default ReferenceStatuses;
